export const flatEaseTypes = [
  'Linear',
];



// WEBPACK FOOTER //
// ./app/javascript/packs/Shared/components/WveInputs/constants.js